module.exports = __webpack_public_path__ + "static/media/triangle.1400a52a.svg";